import {Action} from '@ngrx/store';
import {Dictionary, NgrxManagerAction, Request, RequestMethod, RequestType} from './model';

// QUERY
export const QUERY_STACK_ADD = '[SopiNgrxManager] Query in QUERY_STACK hinzufÃ¼gen';
export const QUERY_STACK_REMOVE = '[SopiNgrxManager] Query von QUERY_STACK enfernen';
export const QUERY_QUEUE_ADD = '[SopiNgrxManager] Query in QUERY_QUEUE hinzufÃ¼gen';
export const QUERY_QUEUE_REMOVE = '[SopiNgrxManager] Query von QUERY_QUEUE enfernen';
export const QUERY_FAILED_ADD = '[SopiNgrxManager] Query in QUERY_FAILED hinzufÃ¼gen';
export const QUERY_FAILED_REMOVE = '[SopiNgrxManager] Query von QUERY_FAILED enfernen';
export const QUERY_STACK_UPDATE = '[SopiNgrxManager] QueryStack Update';
export const QUERY_QUEUE_UPDATE = '[SopiNgrxManager] QueryQueue Update';
export const QUERY_FAILED_UPDATE = '[SopiNgrxManager] QueryFailed Update';
export const QUERY_QUEUE_NEXT = '[SopiNgrxManager] Get next action from query Queue';
export const QUERY_STACK_CLEANUP = '[SopiNgrxManager] Clean up the query stack';
export const DELETE_QUERY_STACK_REQUEST = '[NgrxManager] Delete request from query stack';
export const DELETE_QUERY_QUEUE_REQUEST = '[NgrxManager] Delete request from query queue';
export const DELETE_QUERY_FAILED_REQUEST = '[NgrxManager] Delete request from query failed';
export const DELETE_ALL_QUERY_FAILED_REQUESTS = '[NgrxManager] Delete all requests from query failed';
export const SEND_QUERY_STACK_REQUEST = '[NgrxManager] Send request from query stack';
export const SEND_QUERY_QUEUE_REQUEST = '[NgrxManager] Send request from query queue';
export const SEND_QUERY_FAILED_REQUEST = '[NgrxManager] Send request from query failed';

// COMMAND
export const COMMAND_STACK_ADD = '[SopiNgrxManager] Command in COMMAND_STACK hinzufÃ¼gen';
export const COMMAND_STACK_REMOVE = '[SopiNgrxManager] Command von COMMAND_STACK enfernen';
export const COMMAND_QUEUE_ADD = '[SopiNgrxManager] Command in COMMAND_QUEUE hinzufÃ¼gen';
export const COMMAND_FAILED_ADD = '[SopiNgrxManager] Command in COMMAND_FAILED hinzufÃ¼gen';
export const COMMAND_STACK_UPDATE = '[SopiNgrxManager] CommandStack Update';
export const COMMAND_QUEUE_UPDATE = '[SopiNgrxManager] CommandQueue Update';
export const COMMAND_FAILED_UPDATE = '[SopiNgrxManager] CommandFailed Update';
export const COMMAND_QUEUE_NEXT = '[SopiNgrxManager] Get next action from command Queue';
export const COMMAND_STACK_CLEANUP = '[SopiNgrxManager] Clean up the command stack';
export const DELETE_COMMAND_STACK_REQUEST = '[SopiNgrxManager] Delete request from command stack';
export const DELETE_COMMAND_QUEUE_REQUEST = '[SopiNgrxManager] Delete request from command queue';
export const DELETE_COMMAND_FAILED_REQUEST = '[SopiNgrxManager] Delete request from command failed';
export const DELETE_ALL_COMMAND_FAILED_REQUESTS = '[SopiNgrxManager] Delete all requests from command failed';
export const SEND_COMMAND_STACK_REQUEST = '[SopiNgrxManager] Send request from command stack';
export const SEND_COMMAND_QUEUE_REQUEST = '[SopiNgrxManager] Send request from command queue';
export const SEND_COMMAND_FAILED_REQUEST = '[SopiNgrxManager] Send request from command failed';

// export const COMMAND_QUEUE_REMOVE = '[SopiNgrxManager] Command von COMMAND_QUEUE enfernen';
// export const COMMAND_FAILED_REMOVE = '[SopiNgrxManager] Command von COMMAND_FAILED enfernen';

// GLOBAL
export const CLEAR_REQUESTS = '[SopiNgrxManager] Clear all requests from Store';
export const CLEAR_QUERY_REQUESTS = '[SopiNgrxManager] Clear all query requests from Store';
export const START_SYNC = '[SopiNgrxManager] Start Sync';
export const STOP_SYNC = '[SopiNgrxManager] Stop Sync';

// INSIGHTS
export const INSIGHTS_QUERY_NOT_EXECUTED = '[SopiNgrxManager] Insights :: Query not executed';
export const INSIGHTS_QUERY_EXECUTE = '[SopiNgrxManager] Insights :: Query execution';
export const INSIGHTS_QUERY_SUCCESS = '[SopiNgrxManager] Insights :: Query success';
export const INSIGHTS_QUERY_FAILED = '[SopiNgrxManager] Insights :: Query failed';
export const INSIGHTS_QUERY_FAILED_BAD_REQUEST = '[SopiNgrxManager] Insights :: Query failed with bad request';

export const INSIGHTS_COMMAND_NOT_EXECUTED = '[SopiNgrxManager] Insights :: Command not executed';
export const INSIGHTS_COMMAND_EXECUTE = '[SopiNgrxManager] Insights :: Command execution';
export const INSIGHTS_COMMAND_SUCCESS = '[SopiNgrxManager] Insights :: Command success';
export const INSIGHTS_COMMAND_FAILED = '[SopiNgrxManager] Insights :: Command failed';
export const INSIGHTS_COMMAND_FAILED_BAD_REQUEST = '[SopiNgrxManager] Insights :: Command failed with bad request';

// QUERIES
export class QueryStackAddAction implements Action {
    readonly type = QUERY_STACK_ADD;

    constructor(public key: string, public action: any, public method: RequestMethod, public requestType: RequestType, public date: Date | null = null, public error: any = null) {
    }
}

export class QueryStackRemoveAction implements Action {
    readonly type = QUERY_STACK_REMOVE;

    constructor(public key: string) {
    }
}

export class QueryStackUpdateAction implements Action {
    readonly type = QUERY_STACK_UPDATE;

    constructor(public queryStack: Dictionary<Request>) {
    }
}


export class QueryQueueAddAction implements Action {
    readonly type = QUERY_QUEUE_ADD;

    constructor(public key: string, public action: any, public method: RequestMethod, public requestType: RequestType, public date: Date | null = null, public error: any = null) {
    }
}

export class QueryQueueRemoveAction implements Action {
    readonly type = QUERY_QUEUE_REMOVE;

    constructor(public key: string) {
    }
}

export class QueryQueueUpdateAction implements Action {
    readonly type = QUERY_QUEUE_UPDATE;

    constructor(public queryQueue: Dictionary<Request>) {
    }
}


export class QueryFailedAddAction implements Action {
    readonly type = QUERY_FAILED_ADD;

    constructor(public key: string, public action: any, public method: RequestMethod, public requestType: RequestType, public date: Date | null = null, public error: any = null) {
    }
}

// export class QueryFailedRemoveAction implements Action {
//     readonly type = QUERY_FAILED_REMOVE;
//
//     constructor(public key: string) {
//     }
// }

export class QueryFailedUpdateAction implements Action {
    readonly type = QUERY_FAILED_UPDATE;

    constructor(public queryFailed: Array<Request>) {
    }
}

export class QueryQueueNextAction implements Action {
    readonly type = QUERY_QUEUE_NEXT;

    constructor() {
    }
}

export class QueryStackCleanUpAction implements Action {
    readonly type = QUERY_STACK_CLEANUP;

    constructor() {
    }
}

export class DeleteQueryStackRequestAction implements Action {
    readonly type = DELETE_QUERY_STACK_REQUEST;

    constructor(public request: Request, public index: number) {

    }
}

export class DeleteQueryQueueRequestAction implements Action {
    readonly type = DELETE_QUERY_QUEUE_REQUEST;

    constructor(public request: Request, public index: number) {

    }
}

export class DeleteQueryFailedRequestAction implements Action {
    readonly type = DELETE_QUERY_FAILED_REQUEST;

    constructor(public request: Request, public index: number) {

    }
}

export class SendQueryStackRequestAction implements Action {
    readonly type = SEND_QUERY_STACK_REQUEST;

    constructor(public request: Request, public index: number) {

    }
}

export class SendQueryQueueRequestAction implements Action {
    readonly type = SEND_QUERY_QUEUE_REQUEST;

    constructor(public request: Request, public index: number) {

    }
}

export class SendQueryFailedRequestAction implements Action {
    readonly type = SEND_QUERY_FAILED_REQUEST;

    constructor(public request: Request, public index: number) {

    }
}

export class DeleteAllQueryFailedRequestsAction implements Action {
  readonly type = DELETE_ALL_QUERY_FAILED_REQUESTS;

  constructor() {
  }
}



// COMMANDS
export class CommandStackAddAction implements Action {
    readonly type = COMMAND_STACK_ADD;

    constructor(public key: string, public action: any, public method: RequestMethod, public requestType: RequestType, public date: Date | null = null, public error: any = null) {
    }
}

export class CommandStackRemoveAction implements Action {
    readonly type = COMMAND_STACK_REMOVE;

    constructor(public key: string) {
    }
}

export class CommandStackUpdateAction implements Action {
    readonly type = COMMAND_STACK_UPDATE;

    constructor(public commandStack: Dictionary<Request>) {
    }
}


export class CommandQueueAddAction implements Action {
    readonly type = COMMAND_QUEUE_ADD;

    constructor(public key: string, public action: any, public method: RequestMethod, public requestType: RequestType, public date: Date | null = null, public error: any = null) {
    }
}

// export class CommandQueueRemoveAction implements Action {
//     readonly type = COMMAND_QUEUE_REMOVE;
//
//     constructor(public key: string) {
//     }
// }

export class CommandQueueUpdateAction implements Action {
    readonly type = COMMAND_QUEUE_UPDATE;

    constructor(public commandQueue: Array<Request>) {
    }
}


export class CommandFailedAddAction implements Action {
    readonly type = COMMAND_FAILED_ADD;

    constructor(public key: string, public action: any, public method: RequestMethod, public requestType: RequestType, public date: Date | null = null, public error: any = null) {
    }
}

// export class CommandFailedRemoveAction implements Action {
//     readonly type = COMMAND_FAILED_REMOVE;
//
//     constructor(public key: string) {
//     }
// }

export class CommandFailedUpdateAction implements Action {
    readonly type = COMMAND_FAILED_UPDATE;

    constructor(public commandFailed: Array<Request>) {
    }
}


export class CommandQueueNextAction implements Action {
    readonly type = COMMAND_QUEUE_NEXT;

    constructor() {
    }
}


export class CommandStackCleanUpAction implements Action {
    readonly type = COMMAND_STACK_CLEANUP;

    constructor() {
    }
}


export class ClearRequestsAction implements Action {
    readonly type = CLEAR_REQUESTS;

    constructor() {
    }
}


export class ClearQueryRequestsAction implements Action {
    readonly type = CLEAR_QUERY_REQUESTS;

    constructor() {
    }
}


export class DeleteCommandStackRequestAction implements Action {
    readonly type = DELETE_COMMAND_STACK_REQUEST;

    constructor(public request: Request, public index: number) {

    }
}

export class DeleteCommandQueueRequestAction implements Action {
    readonly type = DELETE_COMMAND_QUEUE_REQUEST;

    constructor(public request: Request, public index: number) {

    }
}

export class DeleteCommandFailedRequestAction implements Action {
    readonly type = DELETE_COMMAND_FAILED_REQUEST;

    constructor(public request: Request, public index: number) {

    }
}

export class SendCommandStackRequestAction implements Action {
    readonly type = SEND_COMMAND_STACK_REQUEST;

    constructor(public request: Request, public index: number) {

    }
}

export class SendCommandQueueRequestAction implements Action {
    readonly type = SEND_COMMAND_QUEUE_REQUEST;

    constructor(public request: Request, public index: number) {

    }
}

export class SendCommandFailedRequestAction implements Action {
    readonly type = SEND_COMMAND_FAILED_REQUEST;

    constructor(public request: Request, public index: number) {

    }
}

export class DeleteAllCommandFailedRequestsAction implements Action {
  readonly type = DELETE_ALL_COMMAND_FAILED_REQUESTS;

  constructor() {
  }
}

export class StopSyncAction implements Action {
    readonly type = STOP_SYNC;

    constructor() {

    }
}

export class StartSyncAction implements Action {
    readonly type = START_SYNC;

    constructor(public checkInternet: boolean = true) {

    }
}


// INSIGHTS

export class InsightsQueryNotExecuted implements Action {
    readonly type = INSIGHTS_QUERY_NOT_EXECUTED;

    constructor(public action: NgrxManagerAction | Action) {

    }
}

export class InsightsQueryExecuted implements Action {
    readonly type = INSIGHTS_QUERY_EXECUTE;

    constructor(public action: NgrxManagerAction | Action) {

    }
}

export class InsightsQuerySuccess implements Action {
    readonly type = INSIGHTS_QUERY_SUCCESS;

    constructor(public action: NgrxManagerAction | Action, public nextAction: NgrxManagerAction | Action) {

    }
}

export class InsightsQueryFailed implements Action {
    readonly type = INSIGHTS_QUERY_FAILED;

    constructor(public action: NgrxManagerAction | Action, public nextAction: NgrxManagerAction | Action) {

    }
}

export class InsightsQueryFailedBadRequest implements Action {
    readonly type = INSIGHTS_QUERY_FAILED_BAD_REQUEST;

    constructor(public action: NgrxManagerAction | Action, public nextAction: NgrxManagerAction | Action) {

    }
}


export class InsightsCommandNotExecuted implements Action {
    readonly type = INSIGHTS_COMMAND_NOT_EXECUTED;

    constructor(public action: NgrxManagerAction | Action) {

    }
}

export class InsightsCommandExecuted implements Action {
    readonly type = INSIGHTS_COMMAND_EXECUTE;

    constructor(public action: NgrxManagerAction | Action) {

    }
}

export class InsightsCommandSuccess implements Action {
    readonly type = INSIGHTS_COMMAND_SUCCESS;

    constructor(public action: NgrxManagerAction | Action, public nextAction: NgrxManagerAction | Action) {

    }
}

export class InsightsCommandFailed implements Action {
    readonly type = INSIGHTS_COMMAND_FAILED;

    constructor(public action: NgrxManagerAction | Action, public nextAction: NgrxManagerAction | Action) {

    }
}

export class InsightsCommandFailedBadRequest implements Action {
    readonly type = INSIGHTS_COMMAND_FAILED_BAD_REQUEST;

    constructor(public action: NgrxManagerAction | Action, public nextAction: NgrxManagerAction | Action) {

    }
}


export type Actions =
    // QUERIES
    QueryStackAddAction
    | QueryStackRemoveAction
    | QueryStackUpdateAction
    | QueryStackCleanUpAction

    | QueryQueueAddAction
    | QueryQueueRemoveAction
    | QueryQueueUpdateAction
    | QueryQueueNextAction

    | QueryFailedAddAction
    // | QueryFailedRemoveAction
    | QueryFailedUpdateAction

    | DeleteQueryStackRequestAction
    | DeleteQueryQueueRequestAction
    | DeleteQueryFailedRequestAction
    | DeleteAllQueryFailedRequestsAction

    | SendQueryStackRequestAction
    | SendQueryQueueRequestAction
    | SendQueryFailedRequestAction

    // COMMANDS
    | CommandStackAddAction
    | CommandStackRemoveAction
    | CommandStackUpdateAction
    | CommandStackCleanUpAction

    | CommandQueueAddAction
    // | CommandQueueRemoveAction
    | CommandQueueUpdateAction
    | CommandQueueNextAction

    | CommandFailedAddAction
    // | CommandFailedRemoveAction
    | CommandFailedUpdateAction

    | DeleteCommandStackRequestAction
    | DeleteCommandQueueRequestAction
    | DeleteCommandFailedRequestAction
    | DeleteAllCommandFailedRequestsAction

    | SendCommandStackRequestAction
    | SendCommandQueueRequestAction
    | SendCommandFailedRequestAction

    | ClearRequestsAction
    | ClearQueryRequestsAction
    | StopSyncAction
    | StartSyncAction

    // INSIGHTS
    | InsightsQueryNotExecuted
    | InsightsQueryExecuted
    | InsightsQuerySuccess
    | InsightsQueryFailed
    | InsightsQueryFailedBadRequest
    | InsightsCommandNotExecuted
    | InsightsCommandExecuted
    | InsightsCommandSuccess
    | InsightsCommandFailed
    | InsightsCommandFailedBadRequest
    ;
